import { set, when } from 'cerebral/operators'

import setSearchCriteria from '../actions/setSearchCriteria.js'

export default [
  setSearchCriteria,
  when('state:users.searchOptions.showSnackbar', [false]),
  {
    false: [set('users.searchOptions.showSnackbar', true)],
    otherwise: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/performSearch.js